



























































































import { Vue, Component, Prop } from 'vue-property-decorator'
import { StudyDummyBaseMethod } from '@/mixins/requests/student/StudyApis.vue'
import { QuestionAnswerType } from '@/mixins/requests/student/StudyApis.vue'

@Component({})
export default class StudyDummy7 extends Vue implements StudyDummyBaseMethod {
  @Prop()
  currentQuestionAnswer?: QuestionAnswerType

  public getQuestionAnswer(): QuestionAnswerType {
    // 入力値（選択、理由）を取得
    let selectEl = document.getElementById('ans_sel') as HTMLSelectElement
    let reasonEl = document.getElementById('reason') as HTMLInputElement
    return { inputs: [selectEl.value, reasonEl.value] }
  }

  public restoreInputedElements(): void {
    // 入力値を復元
    if (!this.currentQuestionAnswer || !this.currentQuestionAnswer.inputs) return
    const selected = this.currentQuestionAnswer.inputs[0]
    const reason = this.currentQuestionAnswer.inputs[1]
    let selectEl = document.getElementById('ans_sel') as HTMLSelectElement
    let reasonEl = document.getElementById('reason') as HTMLInputElement
    if (selectEl && selected) selectEl.value = selected
    if (reasonEl && reason) reasonEl.value = reason
  }

  public clearInputedElements(): void {
    // やり直し
    let selectEl = document.getElementById('ans_sel') as HTMLSelectElement
    let reasonEl = document.getElementById('reason') as HTMLInputElement
    if (selectEl) selectEl.value = ''
    if (reasonEl) reasonEl.value = ''
  }

  private mounted() {
    let scriptEl = document.createElement('script')
    scriptEl.setAttribute('src', '/dummy/study/js/6-2.js')
    ;(document.getElementById('contentsarea7') as HTMLElement).appendChild(scriptEl)

    // tag6-1,tag6-2限定
    let tagEl = document.getElementById('tag6') as HTMLInputElement
    if (tagEl) tagEl.checked = true
    let tagChildEl = document.getElementById('tag6Child')
    if (tagChildEl) tagChildEl.className = 'tag_childes_visible'

    // 入力値を復元
    this.restoreInputedElements()
  }
}
